import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowUpRight, FiBriefcase, FiCoffee, FiCompass } from 'react-icons/fi';
import { trackEvent } from '../../services/analytics';
import { savePlanningDraft } from '../../services/planningDraft';

const PROMPT_CATEGORIES = [
  {
    Icon: FiCompass,
    title: 'Full itineraries',
    prompts: [
      'Plan a 4-day romantic trip to Rome',
      'Five days in Bali on a solo budget',
    ],
  },
  {
    Icon: FiCoffee,
    title: 'Eat, stay, do',
    prompts: [
      'Best sushi under $30 in Tokyo',
      'Boutique hotels near Times Square',
    ],
  },
  {
    Icon: FiBriefcase,
    title: 'Travel logistics',
    prompts: [
      'Find flights from JFK to London',
      'Rent a car in Los Angeles',
    ],
  },
];

const PromptIdeas = () => {
  const navigate = useNavigate();

  const handleUsePrompt = (prompt, category) => {
    trackEvent('prompt_idea_clicked', { category });
    savePlanningDraft(prompt);
    navigate('/chat', { state: { prefillPrompt: prompt } });
  };

  return (
    <section className="oa-prompts" aria-labelledby="prompt-ideas-title">
      <div className="oa-shell">
        <h2 id="prompt-ideas-title">Start with an idea</h2>
        <div className="oa-prompts__grid">
          {PROMPT_CATEGORIES.map(({ Icon, title, prompts }) => (
            <div className="oa-prompt-column" key={title}>
              <div className="oa-prompt-column__header">
                <Icon aria-hidden />
                <h3>{title}</h3>
              </div>
              {prompts.map((prompt) => (
                <button type="button" onClick={() => handleUsePrompt(prompt, title)} key={prompt}>
                  <span>{prompt}</span>
                  <FiArrowUpRight aria-hidden />
                </button>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PromptIdeas;
